<div class="home">
    <div class="home__background" #imgBackground>
        <div class="logo color-white">
            <mv-logo size="2rem" color="white" [brand]="brand"></mv-logo>
            <p mvTypeDirective="{{ type }}"></p>
        </div>
        <div class="logo-img color-tertiary size-25" *ngIf="brand === 'mv'"><i class="mv-icons--design--mv"></i></div>
        <div class="copywrite color-white">© {{ year }} <span mvBrandDirective="{{ brand }}"></span></div>
        <div class="layer" *ngIf="brand === 'mv'">
            <div class="layer__triangle"></div>
        </div>
    </div>
    <div class="home__foreground">
        <mv-lists-description></mv-lists-description>
        <mv-lists-register-forms (showPopup)="showPopup()"></mv-lists-register-forms>
        <mv-lists-home-forms (showPopup)="showPopup()"></mv-lists-home-forms>
    </div>
    <mv-lists-home-wedding-list-search
        isOpen="{{ isOpenPopup }}"
        (popin-closed)="showPopup()"
    ></mv-lists-home-wedding-list-search>
</div>
